import { Shared_Units } from "src/backend/openapi/v1";
import { useCallback } from "react";
import { useUnitsT } from "src/translation-hooks/units";

export const useUnitsTranslation = () => {
  const t = useUnitsT();

  const getUnitsTranslation = useCallback(
    (value: string | Shared_Units) => {
      const enumValue: Shared_Units = typeof value === "string" ? parseInt(value) : value;
      switch (enumValue) {
        case Shared_Units.Millimeter:
          return t.millimeter;
        case Shared_Units.Centimeter:
          return t.centimeter;

        default:
          return "";
      }
    },
    [t]
  );

  return { getUnitsTranslation };
};
